import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserSettingsService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const setSessionConfig = createAsyncThunk(
	'userSettings/setSessionConfig',
	async (payload: { type: 'on' | 'off', param?: string }, { rejectWithValue }) =>
		asyncPayloadCreator(payload, { rejectWithValue }, UserSettingsService.sessionConfig),
);
